import EquipmentHelp from "./EquipmentHelp";

export default EquipmentHelp;
export { EquipmentHelp };
